import React from 'react'
import { Container, Header, Content } from './styles'
import { HealthProcedureAccordionCardList } from '~/components/healthProcedures/HealthProcedureAccordionCardList'
import { ListCardHealthProcedure } from '~/components/healthProcedures/ListCardHealthProcedure'
import { Tag } from '~/components/shared'
import { SidePanel } from '~/components/shared/medicalViews'
import { ContainerTags } from '~/components/shared/medicalViews/sidePanel/styles'
import { ConductAndOmics } from '~/components/healthProcedures/ConductAndOmics'
import { useMaternalInfantHealthProcedures } from '~/context'
import { EHealthProceduresTypes, IFilterTag, IHealthProceduresConduct, IHealthProceduresOmics } from '~/interfaces'
import { message } from '~/services'
import { byTypeEqualToAdmission, filterHealthProceduresPer, isConduct, isOmics, timelineFilters } from '~/utils'
import { removeRepeatedChildEvents } from '~/utils/dashboard/timeline/maternalInfant'
import { getAllEventsInsideAdmissions } from '~/utils/dashboard/timeline/mappers'

export const MaternalInfantSidePanel = (): JSX.Element => {
  const {
    sidePanelEvents,
    openConductCardList,
    setOpenConductCardList,
    openOmicsCardList,
    setOpenOmicsCardList,

    dateFiltersActive,
    typeFiltersActive,
    filterTags,
    removeFilterTag,

    handleSelectedModalHealthProcedures,
    getHealthProcedures
  } = useMaternalInfantHealthProcedures()

  const filterEventsWithoutAdmissionFilter = () => {
    const searchTerms = filterTags?.filter(tag => tag.type === 'searchTerm').map(tag => tag.text)

    return timelineFilters(sidePanelEvents)
      .perDate(dateFiltersActive)
      .perType(typeFiltersActive)
      .perMultipleTextTerms(searchTerms).value
  }

  const filterEventsWithAdmissionFilter = () => {
    const searchTerms = filterTags?.filter(tag => tag.type === 'searchTerm').map(tag => tag.text)
    const typeFiltersWithoutAdmission = typeFiltersActive?.filter(type => type !== EHealthProceduresTypes.ADMISSION)
    const isOnlyFilteringAdmission = typeFiltersActive?.length === 1

    const admissions = filterHealthProceduresPer(getHealthProcedures(), byTypeEqualToAdmission)
    const admissionFilterEvents = getAllEventsInsideAdmissions(admissions, sidePanelEvents)

    if (isOnlyFilteringAdmission) {
      return timelineFilters(admissionFilterEvents)
        .perDate(dateFiltersActive)
        .perType(typeFiltersWithoutAdmission)
        .perMultipleTextTerms(searchTerms).value
    }

    const filterWithoutAdmissions = timelineFilters(sidePanelEvents)
      .perDate(dateFiltersActive)
      .perType(typeFiltersWithoutAdmission)
      .perMultipleTextTerms(searchTerms).value
    const filterAdmissions = timelineFilters(admissionFilterEvents)
      .perDate(dateFiltersActive)
      .perMultipleTextTerms(searchTerms).value

    return [...filterAdmissions, ...filterWithoutAdmissions]
  }

  const isAdmissionFilterSelected = typeFiltersActive?.includes(EHealthProceduresTypes.ADMISSION)
  const filteredEvents = isAdmissionFilterSelected
    ? filterEventsWithAdmissionFilter()
    : filterEventsWithoutAdmissionFilter()

  const uniqueEvents = removeRepeatedChildEvents(filteredEvents)
  const medicalEventsOfConductPanel = filterHealthProceduresPer(uniqueEvents, isConduct)
  const medicalEventsOfOmicsPanel = filterHealthProceduresPer(uniqueEvents, isOmics)

  const handleSelectDataConduct = (healthProcedure: IHealthProceduresConduct) => {
    handleSelectedModalHealthProcedures(healthProcedure)
  }

  const handleSelectDataOmics = (healthProcedure: IHealthProceduresOmics) => {
    handleSelectedModalHealthProcedures(healthProcedure)
  }

  const handleCloseFilterTag = (tag: IFilterTag): void => removeFilterTag(tag)

  return (
    <SidePanel>
      <Container>
        <Header>
          <ContainerTags>
            {filterTags.map((tag, index) => {
              const { id, text, color } = tag
              return <Tag key={`${id}-${index}`} text={text} color={color} onClose={() => handleCloseFilterTag(tag)} />
            })}
          </ContainerTags>
        </Header>
        <Content>
          <ConductAndOmics>
            <HealthProcedureAccordionCardList
              title={message('healthProcedures.conduct')}
              expanded={openConductCardList}
              setExpanded={setOpenConductCardList}
            >
              <ListCardHealthProcedure
                list={medicalEventsOfConductPanel}
                onSelectCard={conduct => handleSelectDataConduct(conduct as IHealthProceduresConduct)}
              />
            </HealthProcedureAccordionCardList>

            <HealthProcedureAccordionCardList
              title={message('healthProcedures.omics')}
              expanded={openOmicsCardList}
              setExpanded={setOpenOmicsCardList}
            >
              <ListCardHealthProcedure
                list={medicalEventsOfOmicsPanel}
                onSelectCard={omics => handleSelectDataOmics(omics as IHealthProceduresOmics)}
              />
            </HealthProcedureAccordionCardList>
          </ConductAndOmics>
        </Content>
      </Container>
    </SidePanel>
  )
}
